import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';
import { formatDate, formatComment, formatNull } from '../Utils/GlobalUtils';

import ClaimACaseModal from '../Components/ClaimACaseModal'

import LoadingLines from '../Components/LoadingLines';

import HeaderPanel from '../Components/HeaderPanel';

const Applications = () => {
    const { openTimeModal } = useTimeModal();

    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    const [isClamACaseModal, setIsClamACaseModal] = React.useState(false);
    const [selectedApplicationId, setSelectedApplicationId] = React.useState('');

    const token = localStorage.getItem('token');
    React.useEffect(() => {
        axios.get('/api/cases-for-application', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            if (response.data.length === 0) {
                setWarning('В данный момент заявки отсутствуют.');
            } else {
                setWarning('');
                setCases(response.data);
            }
        })
        .catch(error => {
            setWarning(`Ошибка загрузки таблицы заявок: ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        })
    }, [reload]);

    const claimACase = (caseId) => {
        axios.put(`/api/remove-agreement?caseId=${caseId}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setReload(true);
            openTimeModal('Заявка на ведение отозвана', 'success');
        })
        .catch(error => {
            openTimeModal('Ошибка при отзыве заявки', 'error');
            console.error('Ошибка при получении данных:', error)
        });
    };


    return (
    <>
        {isClamACaseModal && <ClaimACaseModal applicationId={selectedApplicationId} closeModal={() => {setIsClamACaseModal(false)}} onAddAgreement={() => setReload(true)} />}
        <div className="mainContainer">
            <h1>Заявки</h1>
            <HeaderPanel typePanel='Назад' />
            <div className='tableHeader'>
                <a style={{width: '15%'}}>Номер</a>
                <a style={{width: '17%'}}>Этап</a>
                <a style={{width: '15%'}}>Должник и регион</a>
                <a style={{width: '20%'}}>Последний комментарий</a>
                <a style={{width: '13%'}}>Начальная дата / Конечная дата текущего этапа</a>
                <a className='statusCase' style={{width: '20%'}}>Действия</a>
            </div>
            {loading ? <LoadingLines /> 
            : warning ? <div className='case warningLine'><a>{warning}</a></div>
            : cases.map((caseItem) => (
                <div className='case prevent-active prevent-hover' key={caseItem.id} >
                    <a className='numberCase' style={{width: '15%'}}>{formatNull(caseItem.number)} <span style={{color: 'rgb(169, 169, 169)'}}>{caseItem.internal_number}</span></a>
                    <a style={{width: '17%'}}>{caseItem.status=="В работе" ? (formatNull(caseItem.phaseName)) : (<>Дело завершено</>)}</a>
                    <a className='applicantCase' style={{width: '15%'}}>{formatNull(caseItem.applicant)} {formatNull(caseItem.region)}</a>
                    <a style={{width: '20%'}}>{formatComment(caseItem.comments)}</a>
                    <a style={{width: '13%'}}>{formatDate(caseItem.date_start)} / {formatDate(caseItem.date_end)}</a>
                    <a style={{borderBottom: 'none', borderRight: 'none', width: '20%', display: 'flex', justifyContent: 'center'}}>
                        {caseItem.applicationStatus == 'Не назначен' ? 
                            <button type='button' className='button maxWidth' onClick={() => {setIsClamACaseModal(true); setSelectedApplicationId(caseItem.applicationId);}}>Претендовать на ведение</button>
                            :
                            <button type='button' className='button maxWidth' onClick={() => {claimACase(caseItem.id)}}>Отменить претензию и удалить согласие</button>
                        }
                    </a>
                </div>
            ))}
        </div>
    </>
    )
}

export default Applications;